import { Table, TableProps } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { ColumnsRequesting } from "./Column";
import PaginationComponent from "./Pagination";

const App = ({
  data,
  total,
  currentPage,
  pageSize,
  requestedAtSortOrder,
  onTableChange,
}: {
  data: DataType[];
  total: number;
  currentPage: number;
  pageSize: number;
  requestedAtSortOrder: "ascend" | "descend" | null;
  onTableChange: TableProps<DataType>["onChange"];
}) => {
  return (
    <div className="border border-solid border-[#EBEEF2] rounded-lg">
      <Table<DataType>
        columns={ColumnsRequesting(
          currentPage,
          pageSize,
          total,
          requestedAtSortOrder,
        )}
        dataSource={data}
        pagination={false}
        scroll={{ x: 1233 }}
        tableLayout="fixed"
        className="custom-table"
        rowKey={(record) => record.id?.toString() ?? ""}
        onChange={onTableChange}
        locale={{
          triggerAsc: "クリックして昇順にソート",
          triggerDesc: "クリックして降順にソート",
          cancelSort: "クリックしてソートを解除",
        }}
      />
      <PaginationComponent total={total} />
    </div>
  );
};

export default App;
